import { html, css } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class Signature extends ShadowDOMElement {
	static className = "Signature";
	
	static properties = {
		signatureName: { type: String, attribute: "signature-name" },
		pourAvisName: { type: String, attribute: "pour-avis-name" }
	};

	constructor() {
		super();
		this.signatureName = "signature";
		this.pourAvisName = "review";
	}

	render() {
		return html`
		<title-field label="Signature"></title-field>
		<big-checkbox-field label="Pour avis" name="${this.pourAvisName}"></big-checkbox-field>
		<row-wrapper>
			<text-field label="Signature" name="${this.signatureName}" name="signature"></text-field>
		</row-wrapper>
	    `;
	}
}

customElements.define("signature-field", Signature);
